import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.BACKEND_URL;
  }

  getCurrentUser(): Observable<any> {
    const userString = localStorage.getItem('currentUser');
    const user = userString ? JSON.parse(userString) : null;
    return of(user);
  }

  getCountries(): Observable<any> {
    return this.http.get<any>('../../assets/data/countries.json');
  }

  startFreeTrial(): Observable<any> {
    return this.http.put(this.baseUrl + '/user/free-trial', null);
  }

  getActiveSubscription(): Observable<any> {
    return this.http.get(this.baseUrl + '/user/active-subscription');
  }

  
  
}
